import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../../context/LangContext';
import './Footer.css';

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container footer-grid">
          <div className="footer-brand-col">
            <div className="footer-brand"><span className="footer-om">ॐ</span><div><div className="footer-brand-hi">राघवेंद्र पूजन भंडार</div><div className="footer-brand-en">AYODHYA, UTTAR PRADESH</div></div></div>
            <p className="footer-desc">{t({ hi:'अयोध्या से प्रमाणित पूजा सामग्री, वैदिक ज्योतिष और पंडित सेवाएं। GST पंजीकृत व्यापार।',en:'Authentic Pooja Samagri, Vedic Astrology & Pandit services from Ayodhya. GST registered business.' })}</p>
            <div className="footer-contact">
              <div>📍 राम घाट रोड, अयोध्या — 224123</div>
              <div>📱 +91-98765-43210</div>
              <div>✉️ care@raghavendrabhandar.com</div>
            </div>
          </div>
          <div className="footer-links-col">
            <h4>{t({ hi:'हमारी दुकान', en:'Our Shop' })}</h4>
            <Link to="/shop?category=pooja-samagri">{t({ hi:'पूजा सामग्री', en:'Pooja Samagri' })}</Link>
            <Link to="/shop?category=idols-murti">{t({ hi:'मूर्तियाँ', en:'Idols & Murti' })}</Link>
            <Link to="/shop?category=rudraksha-yantra">{t({ hi:'रुद्राक्ष व यंत्र', en:'Rudraksha & Yantra' })}</Link>
            <Link to="/shop?category=religious-clothing">{t({ hi:'धार्मिक वस्त्र', en:'Religious Clothing' })}</Link>
            <Link to="/shop?category=festival-special">{t({ hi:'त्योहार कलेक्शन', en:'Festival Special' })}</Link>
          </div>
          <div className="footer-links-col">
            <h4>{t({ hi:'ज्योतिष सेवाएं', en:'Astrology Services' })}</h4>
            <Link to="/astrology">{t({ hi:'कुंडली', en:'Kundali' })}</Link>
            <Link to="/rashifal">{t({ hi:'राशिफल', en:'Daily Rashifal' })}</Link>
            <Link to="/panchang">{t({ hi:'पंचांग', en:'Panchang' })}</Link>
            <Link to="/pandit-booking">{t({ hi:'पंडित बुकिंग', en:'Pandit Booking' })}</Link>
            <div className="footer-disclaimer-mini">{t({ hi:'⚠️ ज्योतिष सेवाएं केवल मार्गदर्शन हेतु।',en:'⚠️ Astrology for guidance only.' })}</div>
          </div>
          <div className="footer-links-col">
            <h4>{t({ hi:'ग्राहक सेवा', en:'Customer Service' })}</h4>
            <Link to="/my-orders">{t({ hi:'मेरे ऑर्डर', en:'My Orders' })}</Link>
            <Link to="/track-order">{t({ hi:'ट्रैक ऑर्डर', en:'Track Order' })}</Link>
            <Link to="/profile">{t({ hi:'मेरा अकाउंट', en:'My Account' })}</Link>
            <div className="footer-gstin"><span>GST: 09ABCDE1234F1Z5</span><span>ISO 9001:2015 ✓</span></div>
            <div className="footer-pay-icons">🏦 UPI &nbsp; 💳 Card &nbsp; 📱 Wallet</div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <span>© {year} राघवेंद्र पूजन भंडार, Ayodhya. All rights reserved.</span>
          <span>🛕 जय श्री राम — Made with ❤️ in India</span>
          <div className="footer-bottom-links">
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/refund">Refund</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
